<template>
  <Fieldset>
    <Notice>
      <slot />
    </Notice>
  </Fieldset>
</template>

<script>
import { Fieldset, Notice } from '@dunia/ui';

export default {
  name: 'UiDuniaNoticeFieldset',
  components: {
    Fieldset,
    Notice,
  },
};
</script>
